import { Box, CircularProgress, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Header from "../../../components/Header";

import { authFetch } from "../../../Utils/apiClient";

function ViewSubscription() {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [userDetails, setUserDetails] = useState(null);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await authFetch(`/package/getsubscribe/${id}`);
        const json = await res.json();
        if (json.status && json.result) {
          const item = json.result;
          setUserDetails({
            "User Name": item.User?.profileName || "N/A",
            Email: item.User?.email || "N/A",
            "Package Name": item.Package?.package_name || "N/A",
            "Type of Subscription": item.Package?.typeOfSubscription || "N/A",
            Status: item.active ? "Active" : "Inactive",
            Amount: item.Package?.amount != null ? `$${item.Package.amount}` : "N/A",
            Features: item.Package?.features || "N/A",
            "End Date": item.endDate
              ? new Date(item.endDate).toLocaleDateString("en-US")
              : "N/A",
          });
        }
      } catch (err) {
        console.error("Failed to load subscriber:", err);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [id]);

  if (loading) {
    return (
      <Box m="20px" display="flex" justifyContent="center" alignItems="center" height="50vh">
        <CircularProgress />
      </Box>
    );
  }

  if (!userDetails) {
    return (
      <Box m="20px">
        <Header title={`View Subscribed User Id: ${id}`} subtitle="" />
        <Typography mt={3}>Subscriber not found.</Typography>
      </Box>
    );
  }

  return (
    <Box m="20px" height="80vh" overflow="auto" paddingRight="20px">
      <Header title={`View Subscribed User Id: ${id}`} subtitle="" />
      <Box ml="40px">
        <Grid container spacing={2}>
          {Object.entries(userDetails).map(([field, value]) => (
            <React.Fragment key={field}>
              <Grid item xs={2}>
                <Typography variant="h5" component="span" fontWeight="bold" mt={3}>
                  {field}:
                </Typography>
              </Grid>
              <Grid item xs={1}>
                :
              </Grid>
              <Grid item xs={9}>
                <Typography variant="h5" component="span" mt={3} mr={2}>
                  {value}
                </Typography>
              </Grid>
            </React.Fragment>
          ))}
        </Grid>
      </Box>
    </Box>
  );
}

export default ViewSubscription;
